<template>
<div class="career-routes-small-banner" :class="{ '-side': isSideBanner }">
  <div class="content">
    <h2 class="title">Карьерные маршруты</h2>
    <p class="text">
      Выбери профессию мечты и стань востребованным специалистом в аграрной отрасли
    </p>
  </div>
  <BaseButtonLink name="Выбрать профессию" link="/career-routes" theme="banana" />
  <div class="bg-image" />
</div>
</template>

<script lang="ts" setup>
import { BaseButtonLink } from '~/components/base-ui/buttons'

const img = useImage()
const bgImageDesktopUrl = `url(${img('/pages/career-routes/main-banner/bg-image-desktop.png', { format: 'webp' })})`
const bgImageSmallUrl = `url(${img('/pages/career-routes/main-banner/bg-image-small.png', { format: 'webp' })})`
const bgImageMobile2Url = `url(${img('/pages/career-routes/main-banner/bg-image-mobile-2.png', { format: 'webp' })})`

withDefaults(defineProps<{ isSideBanner?: boolean }>(), { isSideBanner: false })
</script>

<style lang="scss" scoped>
.career-routes-small-banner {
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1280px;
  padding: 24px 40px;
  border-radius: 32px;
  background: linear-gradient(130deg, #ffeba4 0%, #deedff 100%), #dcdfff;

  @include vp-767 {
    flex-direction: column;
    align-items: flex-start;
    padding: 24px 16px;
  }

  >.bg-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: v-bind(bgImageDesktopUrl);
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position-y: -30px;

    @include vp-767 {
      background-image: v-bind(bgImageSmallUrl);
      background-size: auto 55%;
      background-position: bottom right;
    }
  }

  >.content {
    z-index: 10;
    position: relative;
    @extend %flex-column;

    gap: 12px;
    max-width: 318px;

    >.title {
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      color: $color-potato-90;
    }

    >.text {
      font-size: 16px;
      line-height: 24px;
      color: $color-potato-90;
    }
  }

  > :deep(.svoi-button) {
    z-index: 5;
    height: fit-content;
    color: $color-potato-90;
    border-radius: 16px;
    background-color: $color-banana-80;

    @include vp-767 {
      margin-top: 16px;
    }
  }

  &.-side {
    flex-direction: column;
    min-height: 424px;
    padding: 24px 20px;
    border-radius: 20px;
    background: linear-gradient(91deg, #cff2fd 0%, #dcdfff 100%), #fff;

    >.bg-image {
      background-image: v-bind(bgImageMobile2Url);
      background-size: 100% 100%;
      background-position: center;
    }

    > :deep(.svoi-button) {
      margin-top: auto;
      width: 100%;
      border-radius: 50px;
    }
  }
}
</style>
